import React, { forwardRef, useEffect } from 'react'
import { Container, Dialog, IconButton, Slide } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { push } from 'connected-react-router'
import queryString from 'query-string'

import { teamRoute } from '../../../routes/routes'
import { STEPS, resetTeamOnboardingState } from '../../../redux/modules/teamOnboarding'
import { enqueueSnackbar } from '../../../redux/modules/snackbar'
import { selectQuery } from '../../../redux/selectors/routerSelectors'
import { loadUserTeamStart } from '../../../redux/modules/userTeam'
import {
  getViewByStep,
  publishClickedClose,
} from '../../../util/events/teamsOnboardingEventPublishers'
import { selectCurrentUser } from '../../../redux/modules/selectors'
import { selectUserTeam } from '../../../redux/selectors/userTeamSelectors'
import StepTeamName from './StepTeamName'
import StepTeamDomain from './StepTeamDomain'
import StepTeamMembers from './StepTeamMembers'
import StepCreateOrJoinTeam from './StepCreateOrJoinTeam'

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    zIndex: 100,
  },
  initialStepContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    height: '100%',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(5),
    maxWidth: '1300px',
  },
}))

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DialogCreateTeam = ({ currentStep, handleClose }) => {
  const classes = useStyles()

  return (
    <Dialog open fullScreen TransitionComponent={Transition}>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>
      {currentStep === STEPS.CREATE_OR_JOIN && (
        <Container maxWidth={false} className={classes.initialStepContainer}>
          <StepCreateOrJoinTeam />
        </Container>
      )}
      {currentStep !== STEPS.CREATE_OR_JOIN && (
        <Container className={classes.container}>
          {currentStep === STEPS.TEAM_NAME && <StepTeamName />}
          {currentStep === STEPS.TEAM_DOMAIN && <StepTeamDomain />}
          {currentStep === STEPS.TEAM_MEMBERS && <StepTeamMembers />}
        </Container>
      )}
    </Dialog>
  )
}

const DialogCreateTeamWrapper = ({
  currentUser,
  createTeam,
  userTeam,
  currentStep,
  loadUserTeamStart,
  resetTeamOnboardingState,
  enqueueSnackbar,
  push,
  ...rest
}) => {
  const history = useHistory()

  const handleCloseCreateDialog = () => {
    loadUserTeamStart()
    publishClickedClose(getViewByStep(currentStep))
    push({ search: queryString.stringify({ createTeam: undefined }) })
  }

  useEffect(() => {
    if (currentStep === STEPS.COMPLETE) {
      enqueueSnackbar({
        message:
          'Congrats! Your team was successfully created. Be sure to invite everyone on your team to join.',
      })
      resetTeamOnboardingState()
      loadUserTeamStart()
      history.push(teamRoute.path)
    }
  }, [currentStep, enqueueSnackbar, history, loadUserTeamStart, resetTeamOnboardingState])

  const open = Boolean(createTeam) && !userTeam?.team && Boolean(currentUser)
  return open ? (
    <DialogCreateTeam currentStep={currentStep} handleClose={handleCloseCreateDialog} {...rest} />
  ) : null
}

const mapStateToProps = state => {
  const currentUser = selectCurrentUser(state)
  const { currentStep } = state.teamOnboarding
  const { createTeam } = selectQuery(state)
  const userTeam = selectUserTeam(state)

  return {
    currentUser,
    createTeam,
    userTeam,
    currentStep,
  }
}

const mapDispatchToProps = {
  loadUserTeamStart,
  resetTeamOnboardingState,
  enqueueSnackbar,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogCreateTeamWrapper)
